import React from 'react';
import { ThemeProvider } from 'styled-components';
import { propTypes } from './prop-types';
import theme from '../../../../assets/stylesheets/_settings.global.scss';
import { Container, ContentContainer } from '../shared/styles';
import Form from './form-components/form';

export default function EditFund(props) {
  return (
    <ThemeProvider theme={theme}>
      <Container>
        <ContentContainer>
          <h1>Editing Fund</h1>
          <Form {...props} />
        </ContentContainer>
      </Container>
    </ThemeProvider>
  );
}

EditFund.propTypes = propTypes;
